import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import { Link, useHistory } from "react-router-dom";
import ReactPaginate from "react-paginate";
import _ from "lodash";
import "./Custom.css";
import "../loader.css";

function PatientList(props) {
  const [PatientList, setPatientList] = useState([]);
  const [PatientList2, setPatientList2] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [Record, seRecord] = useState([]);
  const [paginatedPosts, setpaginatedPosts] = useState();
  const navigate = useHistory();
  const [isLoading, setIsLoading] = useState(true);
  const [filterText, setfilterText] = useState("");
  const [hasFocus, setHasFocus] = useState(false);
  const [downloadingIds, setDownloadingIds] = useState([]);

  let pageSize = 10;

  useEffect(() => {
    LoadPatient();
  }, [pageSize]);

  const LoadPatient = () => {
    axios.get(`${process.env.REACT_APP_API_URL}/GetAllNewPatient`).then((res) => {
      seRecord(res.data.length);
      if (res.data.length > 10) {
        setPatientList(res.data);

        setpaginatedPosts(_(res.data).slice(0).take(pageSize).value());
      } else {
        setPatientList2(res.data);
      }
      setIsLoading(false);
    });
  };

  const onClearClicked = () => {
    setfilterText("");
    LoadPatient();
  };

  const FilterCases = () => {
    setIsLoading(true);
    if (filterText === "") {
      LoadPatient();
    } else {
      const datavalue = {
        searchString: filterText,
      };

      var authOptions = {
        method: "post",
        url: `${process.env.REACT_APP_API_URL}/GetCasesByName`,
        data: datavalue,
        headers: { "Content-Type": "multipart/form-data" },
      };
      axios(authOptions).then((res) => {
        seRecord(res.data.length);
        if (res.data.length > 10) {
          setPatientList(res.data);
          setpaginatedPosts(_(res.data).slice(0).take(pageSize).value());
        } else {
          setPatientList2(res.data);
        }
        setIsLoading(false);
      });
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter' && hasFocus) {
      FilterCases();
    }
  };

  const handleFocus = () => {
    setHasFocus(true);
  };

  const handleBlur = () => {
    setHasFocus(false);
  };

  const pageCount = PatientList ? Math.ceil(PatientList.length / pageSize) : 0;
  if (pageCount === 1) return null;
  const pages = _.range(1, pageCount + 1);

  const handlePageClick = async (data) => {
    let currentPage = data.selected + 1;
    setCurrentPage(currentPage);
    const startIndex = (currentPage - 1) * pageSize;
    const paginatedPost = _(PatientList)
      .slice(startIndex)
      .take(pageSize)
      .value();
    setpaginatedPosts(paginatedPost);
  };

  // Download SCORM Package
  const downloadScormPackage = async (caseId, itemId) => {
    try {
      // Extract token from localStorage
      let token = null;
      try {
        const raw = localStorage.getItem("state");
        if (raw) {
          const state = JSON.parse(raw);
          token = state.auth?.token;
        }
      } catch (e) {
        console.error("Token parsing failed", e);
        Swal.fire({
          title: "Error",
          text: "Authentication token not found. Please login again.",
          icon: "error",
          confirmButtonText: "Ok",
        });
        return;
      }

      if (!token) {
        Swal.fire({
          title: "Error",
          text: "Authentication token not found. Please login again.",
          icon: "error",
          confirmButtonText: "Ok",
        });
        return;
      }

      // Set downloading state
      setDownloadingIds(prev => [...prev, itemId]);

      // Create FormData
      const formData = new FormData();
      formData.append("caseId", caseId);

      // Make API call
      const response = await axios({
        method: "post",
        url: `${process.env.REACT_APP_API_URL}/GenerateScormPackage`,
        data: formData,
        headers: {
          "Authorization": `Bearer ${token}`,
        },
        responseType: "blob", // Important for file download
      });

      // Create blob link to download
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `SCORM_${caseId}.zip`);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);

      // Remove downloading state
      setDownloadingIds(prev => prev.filter(id => id !== itemId));

      Swal.fire({
        title: "Success",
        text: "SCORM package downloaded successfully!",
        icon: "success",
        confirmButtonText: "Ok",
        timer: 2000,
      });
    } catch (error) {
      console.error("Download error:", error);
      
      // Remove downloading state
      setDownloadingIds(prev => prev.filter(id => id !== itemId));

      Swal.fire({
        title: "Error",
        text: error.response?.data?.message || "Failed to download SCORM package. Please try again.",
        icon: "error",
        confirmButtonText: "Ok",
      });
    }
  };

  // ShowIntents
  const ShowIntents = (pid, pName, pGender) => {
    localStorage.setItem("PatQusId", pid);
    localStorage.setItem("PatName", pName);
    localStorage.setItem("PatGender", pGender);
    // localStorage.setItem('Backvalue',backval)
    localStorage.removeItem("Backvalue");

    //console.log("the vaue", pid)
    const datavalue = {
      id: pid,
      key: "Not",
    };

    var authOptions = {
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/getIntentsByPid`,
      data: datavalue,
      headers: { "Content-Type": "multipart/form-data" },
    };
    axios(authOptions).then((res) => {
      // //console.log("list", res.data)

      //console.log("lecngth", res.data.length)

      localStorage.setItem("QuestionLength", res.data.length);

      res.data.length > 10
        ? navigate.push("/PtientIntentList")
        : navigate.push("/PtientCusIntentList");
      // setIntentList(res.data)
    });
  };
  const EditPatient = (valid) => {
    localStorage.setItem("PatientId", valid);
  };

  const InsertQues = (valid, pName, pGender, backval) => {
    localStorage.setItem("PatQusId", valid);
    localStorage.setItem("PatName", pName);
    localStorage.setItem("BackQues", backval);
    localStorage.setItem("PatGender", pGender);

    //console.log("the vaue", valid)
    const datavalue = {
      id: valid,
      key: "Not",
    };

    var authOptions = {
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/getIntentsByPid`,
      data: datavalue,
      headers: { "Content-Type": "multipart/form-data" },
    };
    axios(authOptions).then((res) => {
      // //console.log("list", res.data)

      //console.log("lecngth", res.data.length)

      localStorage.setItem("QuestionLength", res.data.length);

      // res.data.length > 10 ? navigate.push('/PtientIntentList') :  navigate.push('/PtientCusIntentList')
      // setIntentList(res.data)
    });
  };

  const deletePatient = (value) => {
    //console.log("the vaue", value)

    // Extract token from localStorage.state
    let token = null;
    try {
      const raw = localStorage.getItem("state");
      if (raw) {
        const state = JSON.parse(raw);
        token = state.auth?.token;
      }
    } catch (e) {
      console.error("Token parsing failed", e);
    }

    const datavalue = {
      pId: value,
    };
    var authOptions = {
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/DeletePatient`,
      data: datavalue,
      headers: { "Content-Type": "multipart/form-data", ...(token && { "Authorization": `Bearer ${token}` }) },
    };
    axios(authOptions)
      .then((res) => {
        //console.log("get value", res);
        //console.log("success")

        Swal.fire({
          title: "Success",
          text: "Deleted successfully",
          icon: "success",
          confirmButtonText: "Ok",
        }).then(function () {
          window.location.reload(true);
        });
      })
      .catch((error) => {
        //console.log("error occur", error);
      });
  };
  const BackFunc = () => {
    navigate.push("/index");
  };

  return (
    <>
      <div className="page-content-wrapper">
        {isLoading ? (
          <div className="page-content d-flex justify-content-center align-items-center">
            <div className="my-wrapper">
              <div class="spinner center">
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
              </div>
            </div>

          </div>
        )
          : (
            <div className="page-content">
              <div className="page-bar">
                <div className="page-title-breadcrumb">
                  <div className=" pull-left">
                    <div className="page-title my-0">List of Cases</div>
                  </div>
                </div>
                <div className="page-title-breadcrumb">
                  <div className=" pull-right">
                    <button
                      type="submit"
                      className="btn btn-primary d-inline-block"
                      onClick={BackFunc}
                    >
                      {" "}
                      <i className="fa fa-arrow-left" aria-hidden="true"></i>
                    </button>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="card">
                        <div className="card-head">
                          {/* <header>Patient List</header> */}
                          <header>
                            <div className="d-flex">
                              <div className="flex-grow-1">
                                <input
                                  type="text"
                                  value={filterText}
                                  placeholder="Search by Case Name"
                                  onChange={(e) => setfilterText(e.target.value)}
                                  onKeyDown={handleKeyDown}
                                  onFocus={handleFocus}
                                  onBlur={handleBlur}
                                  autoFocus={true}
                                  style={{ borderTopRightRadius: "0px", borderBottomRightRadius: "0px" }}
                                  className="form-control" />
                              </div>

                              <button
                                type="button"
                                className="btn btn-primary py-2 px-3 me-2 shadow-none"
                                onClick={FilterCases}
                                style={{ border: "1px solid #1e2b38", borderTopLeftRadius: "0px", borderBottomLeftRadius: "0px" }}
                              >
                                <i className="fa fa-search"></i>
                              </button>

                              <button
                                type="button"
                                className="btn py-2 px-3 shadow-none"
                                onClick={onClearClicked}
                                style={{ backgroundColor: "#15bd8c", color: "#FFF", border: "1px solid #15bd8c", borderTopLeftRadius: "0px", borderBottomLeftRadius: "0px" }}
                              >
                                Clear
                              </button>
                            </div>

                          </header>
                          <div className="tools">
                            {/* <a className="fa fa-repeat btn-color box-refresh" href="javascript:;"></a>
                                                <a className="t-collapse btn-color fa fa-chevron-down"
                                                    href="javascript:;"></a>
                                                <a className="t-close btn-color fa fa-times" href="javascript:;"></a> */}
                          </div>
                        </div>
                        <div className="card-body ">
                          <div className="table-responsive">
                            <table className="table table-striped custom-table table-hover" style={{ tableLayout: "fixed" }}>
                              <thead>
                                <tr>
                                  <th>Case ID</th>
                                  <th width="20%"> Name</th>
                                  <th width="15%">Gender</th>
                                  <th width="25%">Case URL</th>
                                  <th>Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                {Record > 10
                                  ? paginatedPosts &&
                                  paginatedPosts.length > 0 &&
                                  paginatedPosts.map((item) => (
                                    <tr key={item.id}>
                                      <td className="text-left">{item.p_id}</td>
                                      <td>
                                        <Link
                                          to="/UpdatePatient"
                                          onClick={() => EditPatient(item.id)}
                                          className=""
                                        >
                                          <a href="#">{item.patient_Nm}</a>
                                        </Link>
                                      </td>
                                      <td className="text-left">
                                        {item.p_Gender}
                                      </td>
                                      <td className="text-left" style={{ whiteSpace: "nowrap", overflow: "hidden" }}>
                                        <a target="_blank" rel="noreferrer" href={item.case_Url}>{item.case_Url}</a>
                                      </td>

                                      <td>
                                        <Link
                                          to="/UpdatePatient"
                                          onClick={() => EditPatient(item.id)}
                                          className="btn btn-primary btn-xs py-2"
                                        >
                                          <i className="fa fa-pencil"></i>
                                        </Link>
                                        <button
                                          className="btn btn-danger btn-xs py-2 ms-1"
                                          onClick={() => {
                                            Swal.fire({
                                              title: "Are you sure?",
                                              text: "You won't be able to revert this!",
                                              icon: "warning",
                                              showCancelButton: true,
                                              confirmButtonColor: "#6777ef",
                                              cancelButtonColor: "#d33",
                                              confirmButtonText:
                                                "Yes, delete it!",
                                            }).then((result) => {
                                              if (result.isConfirmed) {
                                                deletePatient(item.id);
                                              }
                                            });
                                          }}
                                        >
                                          <i className="fa fa-trash-o "></i>
                                        </button>
                                        {item.portal_Id === 62 && (
                                          <button
                                            className="btn btn-success btn-xs py-2 ms-1"
                                            onClick={() => downloadScormPackage(item.p_id, item.id)}
                                            disabled={downloadingIds.includes(item.id)}
                                            title="Download SCORM Package"
                                          >
                                            {downloadingIds.includes(item.id) ? (
                                              <i className="fa fa-spinner fa-spin"></i>
                                            ) : (
                                              <i className="fa fa-download"></i>
                                            )}
                                          </button>
                                        )}
                                      </td>
                                    </tr>
                                  ))
                                  : PatientList2 &&
                                  PatientList2.length > 0 &&
                                  PatientList2.map((item) => (
                                    <tr key={item.id}>
                                      <td className="text-left">{item.p_id}</td>
                                      <td>
                                        <Link
                                          to="/UpdatePatient"
                                          onClick={() => EditPatient(item.id)}
                                          className=""
                                        >
                                          <a href="#">{item.patient_Nm}</a>
                                        </Link>
                                      </td>
                                      <td className="text-left">
                                        {item.p_Gender}
                                      </td>
                                      <td className="text-left" style={{ whiteSpace: "nowrap", overflow: "hidden" }}>
                                        <a target="_blank" rel="noreferrer" href={item.case_Url}>{item.case_Url}</a>
                                      </td>

                                      <td>
                                        <Link
                                          to="/UpdatePatient"
                                          onClick={() => EditPatient(item.id)}
                                          className="btn btn-primary btn-xs py-2"
                                        >
                                          <i className="fa fa-pencil"></i>
                                        </Link>
                                        <button
                                          className="btn btn-danger btn-xs py-2 ms-1"
                                          onClick={() => {
                                            Swal.fire({
                                              title: "Are you sure?",
                                              text: "You won't be able to revert this!",
                                              icon: "warning",
                                              showCancelButton: true,
                                              confirmButtonColor: "#6777ef",
                                              cancelButtonColor: "#d33",
                                              confirmButtonText:
                                                "Yes, delete it!",
                                            }).then((result) => {
                                              if (result.isConfirmed) {
                                                deletePatient(item.id);
                                              }
                                            });
                                          }}
                                        >
                                          <i className="fa fa-trash-o "></i>
                                        </button>
                                        {item.portal_Id === 62 && (
                                          <button
                                            className="btn btn-success btn-xs py-2 ms-1"
                                            onClick={() => downloadScormPackage(item.p_id, item.id)}
                                            disabled={downloadingIds.includes(item.id)}
                                            title="Download SCORM Package"
                                          >
                                            {downloadingIds.includes(item.id) ? (
                                              <i className="fa fa-spinner fa-spin"></i>
                                            ) : (
                                              <i className="fa fa-download"></i>
                                            )}
                                          </button>
                                        )}
                                      </td>
                                    </tr>
                                  ))}
                              </tbody>
                            </table>
                          </div>
                          {Record > 10 ? (
                            <ReactPaginate
                              previousLabel={"Prev"}
                              nextLabel={"Next"}
                              breakLabel={"..."}
                              pageCount={pageCount}
                              marginPagesDisplayed={2}
                              pageRangeDisplayed={3}
                              onPageChange={handlePageClick}
                              containerClassName={
                                "pagination justify-content-center"
                              }
                              pageClassName={"page-item"}
                              pageLinkClassName={"page-link"}
                              activeClassName={"active"}
                              previousClassName={"page-item"}
                              nextClassName={"page-item"}
                              previousLinkClassName={"page-link"}
                              nextLinkClassName={"page-link"}
                            />
                          ) : (
                            <div></div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )
        }
      </div>
    </>
  );
}

export default PatientList;